import { isAllowed } from './permissionHelpers';

// See documentation of permissions stuff here:
// https://novicell.atlassian.net/wiki/spaces/SPACE/pages/3610870000/SPACEIN+Permissions

// When we go to the switch space page, we give them some default permissions as the BE doesn't deliver them.
const SWITCH_SPACE_PAGE_PERMISSIONS = {
  'settings.*': true
}

export default {
  namespaced: true,
  state: {
    permissions: {}
  },
  getters: {
    permissions: (state) => state.permissions,
    isAllowed: (state) => {
      return (permissionToCheck) => {
        return isAllowed(permissionToCheck, state.permissions);
      };
    },
    ifPermissions: (state) => Object.keys(state.permissions).length,
  },
  mutations: {
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    }
  },
  actions: {
    setPermissions({ commit }, permissions) {
      commit('SET_PERMISSIONS', permissions);
    },
    clearPermissions({commit}) {
      commit('SET_PERMISSIONS', {})
    },
    setSwitchSpacePagePermissions({commit}) {
      commit('SET_PERMISSIONS', SWITCH_SPACE_PAGE_PERMISSIONS)
    }
  }
};
